/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-07 15:25:55
 * @Description: 
 */
import clsx from "clsx";
import { autorun } from "mobx";
import React from "react";
import { IconVip, IconVipNew } from "src/assets";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTImageStore from "src/store/FTImageStore";
import FTUserStore from "src/store/FTUserStore";
import FTLang from "src/utils/FTLang";
import FTButton from "../FTButton/FTButton";
import "./FTWatermark.scss"

interface Iprops {
  theme?: "text" | "btn"
}
export default function FTWatermark(props: Iprops) {
  let { theme = "btn" } = props
  let [waterMarkText, setWaterMarkText] = React.useState("goart_remove_watermark")
  let [showWaterMark, setShowWatermark] = React.useState(false)
  const removeWaterMark = () => {
    if(FTUserStore.userInfo) {
      !FTUserStore.isVip && FTUserStore.showPaymnet({
        vipType: "vip",
        position: "goart_remove_watermark",
        otherParam: {
          scenesId: "012"
        }
      })
    } else {
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_remove_watermark"
        }, 
        isShowScenses: true,
        otherParam: {
          scenesId: "015",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          removeWaterMark()
        }
      })
    }
  }

  React.useEffect(() => {
    autorun(() => {
      let watermark = ""
      let { showFreeTry, showDiscount, isVip } = FTUserStore
      let { currentEffect } = FTImageStore
      if(showDiscount !== 0) {
        watermark = "goart_remove_watermark_discount"
      } else if(showFreeTry) {
        watermark = "goart_remove_watermark_free"
      } else {
        watermark = "goart_remove_watermark"
      }
      setWaterMarkText(watermark)
      setShowWatermark(!isVip && currentEffect)
    })
  }, [])

  if(!showWaterMark) return <></>

  return <FTButton onClick={ () => removeWaterMark()} className={clsx("canvas_extra_remove_btn", theme)}>
    { theme === "text" ? <IconVipNew /> : <IconVip />}
    {FTUserStore.showDiscount ? FTLang._(waterMarkText, {
      discount_cn: FTUserStore.showDiscount / 10,
      discount_en: (100 - FTUserStore.showDiscount),
      discount_jp: (100 - FTUserStore.showDiscount) / 10
    }) : FTLang._(waterMarkText)}
    {/* { FTLang._("goart_remove_watermark_normal")} */}
  </FTButton>
}